import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/consolidacionEnvio';
import ConsolidacionList from './ConsolidacionList';


const ms2p = (state) => {
  return {
    ...state.prd_consolidacion_envio,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ConsolidacionList);
